import {
  LinearProgress,
  Box,
  Typography,
  makeStyles,
  Card,
  CardContent,
  Collapse,
  CardActions,
  IconButton,
  Divider,
  CardActionArea,
} from "@material-ui/core";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@material-ui/lab";
import { navigate } from "@reach/router";
import Skeleton from "@material-ui/lab/Skeleton";
import { useEffect, useState } from "react";
import { MdInfoOutline } from "react-icons/md";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: 0,
  },
  cardActionArea: {
    paddingBottom: theme.spacing(2),
  },
  text: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(1.5),
  },
  progress: {
    marginBottom: theme.spacing(1),
  },
  levelText: {
    color: theme.palette.text.secondary,
  },
}));

function PointsBar(props) {
  const classes = useStyles();
  const [open, setopen] = useState(false);

  useEffect(() => {
    props.openTrue && setopen(true);
  }, [props.openTrue]);

  const levelNames = [
    "Einsteiger*in",
    "Entdecker*in",
    "Begeisterte*r",
    "Sportskanone",
    "Ausdauersportler*in",
    "Leistungssportler*in",
    "Profisportler*in",
    "Olympionik*in",
    "Unschlagbare",
    "Legende",
  ];

  function getLevelPoints(level) {
    let levelValue = 0;
    for (let i = 1; i <= level; i++) {
      levelValue += level * 25;
    }
    return levelValue;
  }

  function getLevel() {
    let levelPoints = 0;
    let curLevel = 0;
    while (levelPoints <= props.sumTime / 60) {
      levelPoints = getLevelPoints(curLevel);
      curLevel++;
    }
    return curLevel - 1;
  }

  function getDistanceLast(index) {
    let length = levelNames.length + 1;
    return index - length + 2;
  }

  const ConditionalWrapper = ({ condition, wrapper, children }) =>
    condition ? wrapper(children) : children;

  return (
    <Card variant={props.outlined && "outlined"}>
      <ConditionalWrapper
        condition={props.navigateErfolge}
        wrapper={(children) => (
          <CardActionArea
            className={classes.cardActionArea}
            onClick={() => navigate("/erfolge", { state: { openInfo: true } })}
          >
            {children}
          </CardActionArea>
        )}
      >
        <CardContent className={classes.root}>
          <Box width="100%">
            <div className={classes.text}>
              <Typography variant="subtitle1" gutterBottom>
                {props.loading ? (
                  <Skeleton variant="text" width={120} />
                ) : levelNames[getLevel() - 1] ? (
                  levelNames[getLevel() - 1]
                ) : (
                  `${levelNames[levelNames.length - 1]} ${getDistanceLast(getLevel())}`
                )}
              </Typography>
              <Box textAlign="right">
                <Typography variant="subtitle1" className={classes.levelText} gutterBottom>
                  {props.loading ? (
                    <Skeleton variant="text" width={80} />
                  ) : (
                    <>
                      {Math.floor(props.sumTime / 60)}{" "}
                      {Math.floor(props.sumTime / 60) === 1 ? "Punkt" : "Punkte"} |{" "}
                      <span style={{ whiteSpace: "nowrap" }}>Level {getLevel()}</span>
                    </>
                  )}
                </Typography>
              </Box>
            </div>
            <LinearProgress
              variant="determinate"
              value={
                ((props.sumTime / 60 - getLevelPoints(getLevel() - 1)) /
                  (getLevelPoints(getLevel()) - getLevelPoints(getLevel() - 1))) *
                100
              }
              className={classes.progress}
            />
            <Typography variant="subtitle2" color="primary">
              {props.loading ? (
                <Skeleton variant="text" width={80} />
              ) : (
                <>
                  {getLevelPoints(getLevel()) - Math.floor(props.sumTime / 60)} Punkte bis Level{" "}
                  {getLevel() + 1}
                </>
              )}
            </Typography>
          </Box>
        </CardContent>
        {props.info && (
          <CardActions disableSpacing style={{ paddingTop: "0" }} onClick={() => setopen(!open)}>
            <IconButton
              color={open ? "primary" : "default"}
              style={{ marginLeft: "auto", padding: "0" }}
            >
              <MdInfoOutline />
            </IconButton>
          </CardActions>
        )}
        <Collapse in={open && !props.navigateErfolge} timeout="auto" unmountOnExit>
          <Divider />
          <CardContent>
            <Typography variant="subtitle2">
              Für jede Minute absolviertes Training erhältst du einen Punkt. Jedes Level stellt eine
              neue Herausforderung dar und eröffnet dir eine neue Bezeichnung.
            </Typography>
            <Timeline style={{ padding: "0 0" }}>
              {[...Array(getLevel() + 1)].map((elementInArray, index) => (
                <TimelineItem style={{ minHeight: "40px" }} key={index}>
                  <TimelineOppositeContent style={{ paddingLeft: "0", paddingRight: "10px" }}>
                    <Typography variant="body2" color="primary" noWrap>
                      {index + 1}: {getLevelPoints(index)} P. {getLevel() !== index && "✓"}
                    </Typography>
                  </TimelineOppositeContent>
                  <TimelineSeparator>
                    <TimelineDot />
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent style={{ paddingRight: "0", paddingLeft: "10px" }}>
                    <Typography variant="body2">
                      {getLevel() !== index
                        ? index + 1 <= levelNames.length
                          ? levelNames[index]
                          : `${levelNames[levelNames.length - 1]} ${getDistanceLast(index + 1)}`
                        : "?"}
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              ))}
            </Timeline>
          </CardContent>
        </Collapse>
      </ConditionalWrapper>
    </Card>
  );
}

export default PointsBar;
